import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import { Toaster } from "@/components/ui/sonner";

import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import OrdersPage from "@/pages/OrdersPage";
import CashPage from "@/pages/CashPage";
import DebtsPage from "@/pages/DebtsPage";
import ReceivablesPage from "@/pages/ReceivablesPage";
import ReconciliationPage from "@/pages/ReconciliationPage";
import AdvancesPage from "@/pages/AdvancesPage";
import ReportsPage from "@/pages/ReportsPage";
import OrganizationPage from "@/pages/OrganizationPage";

const Shell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>
    <AppShell>{children}</AppShell>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Shell><DashboardPage /></Shell>} />
          <Route path="/integrations" element={<Shell><IntegrationsPage /></Shell>} />
          <Route path="/orders" element={<Shell><OrdersPage /></Shell>} />
          <Route path="/receivables" element={<Shell><ReceivablesPage /></Shell>} />
          <Route path="/reconciliation" element={<Shell><ReconciliationPage /></Shell>} />
          <Route path="/cash" element={<Shell><CashPage /></Shell>} />
          <Route path="/debts" element={<Shell><DebtsPage /></Shell>} />
          <Route path="/advances" element={<Shell><AdvancesPage /></Shell>} />
          <Route path="/reports" element={<Shell><ReportsPage /></Shell>} />
          <Route path="/organization" element={<Shell><OrganizationPage /></Shell>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
